module.exports = __webpack_public_path__ + "static/program-3ed6dcbefac8f64bb10c7caee91fd885.gif";